﻿export class TitleModel {
    id: string;
    name: string;
    parentTitleId: string;
    parentTitle: TitleModel;
    topicId: string;
    order: number;
    
}